var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 100,
    viewBox: "0 0 96 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 60H50V25H40V60ZM55 52.5H65V30H55V52.5ZM25 50H35V30H25V50ZM15 100V78.5C10.25 74.1667 6.56333 69.105 3.94 63.315C1.31667 57.525 0.00333333 51.42 0 45C0 32.5 4.375 21.875 13.125 13.125C21.875 4.375 32.5 0 45 0C55.4167 0 64.6467 3.06333 72.69 9.19C80.7333 15.3167 85.9617 23.295 88.375 33.125L94.875 58.75C95.2917 60.3333 95 61.7717 94 63.065C93 64.3583 91.6667 65.0033 90 65H80V80C80 82.75 79.0217 85.105 77.065 87.065C75.1083 89.025 72.7533 90.0033 70 90H60V100H50V80H70V55H83.5L78.75 35.625C76.8333 28.0417 72.75 21.875 66.5 17.125C60.25 12.375 53.0833 10 45 10C35.3333 10 27.0833 13.375 20.25 20.125C13.4167 26.875 10 35.0833 10 44.75C10 49.75 11.0217 54.5 13.065 59C15.1083 63.5 18.0033 67.5 21.75 71L25 74V100H15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.17b9b17ab839a98e5a7f5996c4e8aa6e.svg";
export { ForwardRef as ReactComponent };